import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';// To use modal boxes
import { OverlayRef, Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { LoaderComponent } from '../../loader/loader.component';
import { ajaxservice } from '../../../../../app/services/ajaxservice';
import { RaisecomplaintComponent } from '../raisecomplaint/raisecomplaint.component';

@Component({
  selector: 'kt-existingenduser',
  templateUrl: './existingenduser.component.html',
  styleUrls: ['./existingenduser.component.scss'],
  providers: [RaisecomplaintComponent]
})
export class ExistingenduserComponent implements OnInit {
  Facility: FormGroup;
  overlayRef: OverlayRef;         // for loader
  LoaderComponentPortal: ComponentPortal<LoaderComponent>;
  showTable: boolean = false;
  customer_details: any;
  product_details: any;
  product_list: any;
  site_details: any;
  enduser_details: any;
  billingaddress_details: any;
  modal_properties: any;
  products: any;
  locations: any;
  location_id: any;
  product_id: any;
  dtOptions: DataTables.Settings = {};
  constructor(
    private toastr: ToastrService,
    private modalService: NgbModal,
    private overlay: Overlay,
    private chRef: ChangeDetectorRef,
    public ajax: ajaxservice
  ) {
    this.Facility = new FormGroup({
      'facilityname': new FormControl(''),
      'facilitynature': new FormControl(''),
      'contactnumber': new FormControl(''),
      'email_id': new FormControl(''),
      'product_id':new FormControl(''),
      'location_id':new FormControl(''),
      'barcode': new FormControl('',[Validators.required, Validators.minLength(8), Validators.maxLength(8), Validators.pattern("^[0-9]*$")])
    });
  }

  ngOnInit(): void {
    this.overlayRef = this.overlay.create({                                    //loader overlay                   
      positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
      hasBackdrop: true,
    });
    this.LoaderComponentPortal = new ComponentPortal(LoaderComponent); 
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      language: {
				"zeroRecords": 'No Data Available'
			}
    }
    this.get_customer_contract_details();
  }
  // function for getting the product and location details
  get_ticket_product_location() {
    var emp_code = localStorage.getItem('pro_employee_code')                     //declare emp_code for localstorage
    var data = { "employee_code": emp_code }
    var url = 'get_ticket_product_location/?';                                  // api url for getting the details
    this.ajax.getdataparam(url,"employee_code",emp_code).subscribe((result) => {
      if (result.response.response_code == "200") {
        this.products = result.response.product;              //storing the api response in the array
        this.locations = result.response.location;              //storing the api response in the array     
      }
    }, (err) => {
      console.log(err);                                        //prints if it encounters an error
    });
  }
     //filter
   filter_tickets() {
    this.location_id = this.Facility.value.location_id;
    this.product_id = this.Facility.value.product_id;
    if (this.location_id == "") {
      this.location_id = null;
    }
    else {
      this.location_id = this.Facility.value.location_id;
    }
    if (this.product_id == "") {
      this.product_id = null;
    }
    else {
      this.product_id = this.Facility.value.product_id;
    }
    // console.log(this.radiochange_value,"this.radiochange_value")
    // if (this.radiochange_value == 1) {
    //   this.showTable = false;
    //   this.get_working_in_progress();       //call the work in progress api
    // }
    // else if (this.radiochange_value == 2) {
    //   this.get_esclated_tickets();            //call the escalated api
    // }
    // else if (this.radiochange_value == 3) {
    //   this.get_spare_requested_ticket();            //call the escalated api
    // }
  }
    reset(){
    // this.radiochange_value = this.ProductLocation.value.lable_type;
      this.location_id = null;
      this.product_id = null;
      this.Facility.controls['product_id'].setValue('');
      this.Facility.controls['location_id'].setValue('');
      this.Facility.controls['barcode'].setValue('');
      this.product_details =this.product_list;
      this.chRef.detectChanges();
      // if (this.radiochange_value == 1) {
      //   this.chRef.detectChanges();
      //   this.get_working_in_progress();     // call work in progress api
      // }
      // else if (this.radiochange_value == 2) {
      //   this.chRef.detectChanges();
      //   this.get_esclated_tickets();              // call escalated ticket api
      // }
      // else if (this.radiochange_value == 3) {
      //   this.chRef.detectChanges();
      //   this.get_spare_requested_ticket();            //call spare request ticket api 
      // }
  }
  get_customer_contract_details() {
    this.overlayRef.attach(this.LoaderComponentPortal);
    this.showTable = false;
    var url = 'get_customer_contract_details/';
    var data = {
      'customer_code': localStorage.getItem('reg_cust_code'),
      'site_id': '',
      'serial_no': ''
    }
    this.ajax.postdata(url,data).subscribe((result) => {
      if(result.response.response_code == 200) {
        this.customer_details = result.response.customer_details;
        // localStorage.setItem('pro_bearer_token', this.customer_details.);
        this.product_list = result.response.product_details;
        this.site_details = result.response.site_details;
        this.enduser_details = result.response.site_contact_details;
        this.billingaddress_details = result.response.billing_address_details;
        this.product_details = this.product_list;
        this.showTable = true;
        this.Facility.patchValue({
          'facilityname': this.customer_details.customer_name,
          'contactnumber': this.customer_details.contact_number,
          'email_id': this.customer_details.email_id
        });
        if(this.customer_details.customer_type == 1) {
          this.Facility.controls['facilitynature'].setValue('Private');
        } else {
          this.Facility.controls['facilitynature'].setValue('Government');
        }
        this.chRef.detectChanges();
        this.overlayRef.detach();
        
      } else if (result.response.response_code == "400" || result.response.response_code == "500") {
        this.toastr.error(result.response.message, 'Error');        //toastr message for error
        this.chRef.detectChanges();
        this.overlayRef.detach();
      }
      else {
        this.toastr.error(result.response.message, 'Error');        //toastr message for error
        this.chRef.detectChanges();
        this.overlayRef.detach();
      }
    }, (err) => {
      console.log(err);                                             //prints if it encounters an error
      // this.overlayRef.detach();
    });
  }

  searchBarCode() {
    var key = this.Facility.value.barcode;
    if (key != '' && key != null) {
      var product = this.product_list.filter((item) => item.serial_no == key);
      this.product_details = product;
      this.chRef.detectChanges();
    } else {
      this.product_details = this.product_list;
    }
  }

  raisecomplaint(product) {
    this.modal_properties = {
      customer_code: this.customer_details.customer_code,
      customer_contract_id: product.customer_contract_id,
      product_id: product.product.product_id,
      product_sub_id: product.sub_product.product_sub_id,
      model_no: product.model_no,
      part_number: product.part_number,
      serial_no: product.serial_no,
      end_userdetails_id: this.enduser_details.end_userdetails_id,
      billing_address_id: this.billingaddress_details.billing_address_id,
      contract_type_id: product.contract_type.contract_type_id
    }
    const modalRef: NgbModalRef = this.modalService.open(RaisecomplaintComponent, {
      size: 'lg', //specifies the size of the dialog box
      windowClass: "center-modalsm",
      backdrop: 'static',              //popup outside click by Sowndarya
      keyboard: false
    });
    modalRef.componentInstance.modal_properties = this.modal_properties;
  }
  // nubmer only type
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  // reset  add harish Mar25-2025
  // reset(){
  //   this.Facility.controls['barcode'].setValue('');
  //   this.product_details =this.product_list;
  //   this.chRef.detectChanges();
  // }

}
